import {gql} from "@irati/utils/gql"

export const AllBudgetCategoriesFragment = gql`
  fragment AllBudgetCategoriesFragment on BudgetCategories {
    unassigned {
      uuid
      walletId
      name
      amount
      currency
      percentage
      metadata {
        color
        createdAt
        createdBy
        updatedAt
        updatedBy
      }
    }
    categories {
      uuid
      walletId
      name
      amount
      currency
      percentage
      metadata {
        color
        createdAt
        createdBy
        updatedAt
        updatedBy
      }
      tag {
        uuid
        name
      }
    }
  }
`
